import { render } from "./PreSelectedFilters.vue?vue&type=template&id=4b789eb8&ts=true"
import script from "./PreSelectedFilters.vue?vue&type=script&lang=ts"
export * from "./PreSelectedFilters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__